import { queryClient } from 'index';
import { useTranslation } from 'react-i18next';
import { useInfiniteQuery, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import {
  addCompanyToModel,
  getEligibleCompaniesForModel,
} from 'services/ModelsCompaniesService';
import { getToastErrorMessage, LogyxError } from 'services/api/errors';
import { ReactMutationKeys } from 'services/api/reactMutationKeys';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { getNextPageParam } from 'utils/getNextPageParam';

export const useGetCompaniesEligibleForModel = (
  perPage: number,
  modelId: number,
  companyId: number,
  searchBy: string,
  isOpen: boolean
) =>
  useInfiniteQuery({
    queryKey: [
      ReactQueryKeys.GET_COMPANIES_ELIGIBLE_FOR_MODEL,
      modelId,
      companyId,
      perPage,
      searchBy,
    ],
    queryFn: ({ pageParam = 1 }) =>
      getEligibleCompaniesForModel(
        modelId,
        companyId,
        pageParam,
        perPage,
        searchBy
      ),
    getNextPageParam,
    onSuccess: (data) => {
      return data;
    },
    enabled: isOpen,
  });

export const useAddCompanyToModel = (companyId: number, modelId: number) => {
  const { t } = useTranslation();
  return useMutation(
    (buyerId: number) => addCompanyToModel(companyId, buyerId, modelId),
    {
      onSuccess: () => {
        toast.success(t('Successfully added company to model'));
        queryClient.invalidateQueries(ReactQueryKeys.GET_COMPANIES_FOR_MODEL);
      },
      onError: (error: LogyxError) => {
        toast.error(getToastErrorMessage(error), {
          toastId: ReactMutationKeys.ADD_COMPANY_TO_MODEL,
        });
      },
      mutationKey: ReactMutationKeys.ADD_COMPANY_TO_MODEL,
    }
  );
};
